import NoExternalAccount from "features/onboarding/methodSettings/signalsGroup/myGroupsMessages/NoExternalAccount";
import AccountTypeButtons from "features/onboarding/methodSettings/signalsGroup/connectExternalAccount/AccountTypeButtons";
import React, { CSSProperties } from "react";
import { ExternalAccountType } from "@shared/types";

interface ConnectExternalAccountTopSectionProps {
  accountType?: ExternalAccountType;
  setAccountType: (accountType: ExternalAccountType) => void;
  style?: CSSProperties;
  showEmptyState?: boolean;
  showLink?: boolean;
}

const ConnectExternalAccountTopSection = ({
  accountType,
  setAccountType,
  style,
  showEmptyState = true,
  showLink,
}: ConnectExternalAccountTopSectionProps) => {
  return (
    <div style={style}>
      {showEmptyState && (
        <NoExternalAccount showButton={false} showLink={showLink} />
      )}
      <AccountTypeButtons
        accountType={accountType}
        setAccountType={setAccountType}
        style={{ marginTop: 8, width: "100%", columnGap: 16 }}
      />
    </div>
  );
};

export default ConnectExternalAccountTopSection;
